import { Controller } from "@hotwired/stimulus"
import { mountExercise } from "../exercise_widgets/index.js"
import { saveResult, parseExerciseJson } from "../modules/exercise_result_store.js"

export default class extends Controller {
  static targets = ["payload", "mount"]
  static values = {
    locale: { type: String, default: "en" },
    exercise: Object
  }

  connect() {
    const exercise = this.exerciseDocument()

    this.handle = mountExercise(exercise, this.mountElement(), {
      locale: this.localeValue,
      callbacks: { onComplete: (result) => this.persist(result) }
    })
  }

  disconnect() {
    if (this.handle) this.handle.unmount()
    this.handle = null

    if (this.mountNode && this.mountNode.parentNode) {
      this.mountNode.parentNode.removeChild(this.mountNode)
    }
    this.mountNode = null
  }

  exerciseDocument() {
    if (this.hasPayloadTarget) {
      const parsed = parseExerciseJson(this.payloadTarget.textContent)
      if (parsed) return parsed
    }

    return this.hasExerciseValue ? this.exerciseValue : null
  }

  mountElement() {
    if (this.hasMountTarget) return this.mountTarget

    if (!this.mountNode) {
      this.mountNode = document.createElement("div")
      this.element.appendChild(this.mountNode)
    }
    return this.mountNode
  }

  persist(result) {
    saveResult(result && result.exercise_id, result)
    this.dispatch("complete", { detail: { result } })
  }
}
